export default __webpack_public_path__ + "static/stasis-aa4824470bbd96f9020e08dd4d94bd3b.png";